import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/eca_rule_outcomes',
  component: Management,
  redirect: '/eca_rule_outcomes/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/eca_rule_outcomes/List'),
      meta: {
        auth: Auth.listTriggers
      }
    }
  ]
}
